import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2025 } from '../SchoolProgram2023/components';

const GeetaDaraClass82025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/school-programs/GeetaDaraClass82025/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/school-programs/GeetaDaraClass82025/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/school-programs/GeetaDaraClass82025/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/school-programs/GeetaDaraClass82025/4.webp`;


   
 const photos = [
         {
  src: p1,
  source: p1,
  rows: 1,
  cols: 1,
},
{
  src: p2,
  source: p2,
  rows: 1,
  cols: 1,
},
{
  src: p3,
  source: p3,
  rows: 1,
  cols: 1,
}, 
{
  src: p4,
  source: p4,
  rows: 1,
  cols: 1,
}

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h5' align='center'>
                              GEETHA DHARA - Class 8
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                             Class: 8       Date: 2 February 2026
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                               The <b>Geetha Dhara</b> – Bhagavad Geetha sessions for Class 8 students were conducted in two phases: the first phase on Wednesday, 21 January 2026 and the second phase on Tuesday, 2 February 2026.It was an enriching and spiritually uplifting experience that beautifully blended learning with values. The sessions aimed to introduce students to the timeless wisdom of the Bhagavad Geetha and help them understand its relevance in everyday life.
                                <br></br>
                                The sessions were led by Ms Sunita Rajesh, who guided the students through selected Bhagavad Geetha shlokas, focussing on correct chanting, pronunciation and rhythm. She thoughtfully explained the meaning and essence of each verse, enabling students to grasp the deeper philosophical and moral teachings embedded in the Geetha. Her clear explanations and engaging interaction kept the students attentive and inspired throughout the workshop.
                                <br></br>
                               The chanting sessions created a serene and focussed atmosphere, allowing students to experience the calming and reflective power of the sacred verses. Emphasis was laid on how the teachings of the Bhagavad Geetha encourage values such as discipline, self-control, righteousness and inner strength.
                               <br></br>
                               The sessions were highly appreciated for its meaningful content and effective delivery. Students actively participated and expressed keen interest, making the sessions both informative and memorable. Geetha Dhara proved to be a valuable initiative that left a lasting impact on the young minds, nurturing spiritual awareness alongside academic growth.
                              <br></br> <br></br>
                               
                                </Typography>
                            </Box>
                            {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “National Sports Day at National Public School, Yeshwanthpur was truly a day of fun, learning, and inspiration.”

                                <br />
                            </Typography> */}

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 500}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default GeetaDaraClass82025;